import React, {useContext} from 'react';
import {classes, style} from './doppe-action-type-widget-content-layout-new.st.css';
import {
    DoppeActionTypeWidgetContentSection
} from '../doppe-action-type-widget-content-section/doppe-action-type-widget-content-section';
import {uiPartCreateMarking, Values} from '@wix/devzai-utils-common';
import {DoppeViewerScrollView} from '../doppe-viewer-scroll-view/doppe-viewer-scroll-view';
import {FlexLayout} from '@wix/devzai-common-client';
import {ScrollViewScrollingDirection} from '@wix/devzai-utils-react';
import {DoppeActionTypeWidgetLayoutContext} from '../doppe-action-type-widget-layout/doppe-action-type-widget-layout';
import {DoppeActionTypeWidgetContentLayoutNewParts} from './doppe-action-type-widget-content-layout-new.ui-parts';
import {DoppeActionContentSection} from '../../client-server-common/types/doppe-action-content-section';

export const DoppeActionTypeWidgetContentLayoutContentAlignment = {
    Default: 'default',
    Center: 'center'
} as const;

export type DoppeActionTypeWidgetContentLayoutContentAlignment = Values<typeof DoppeActionTypeWidgetContentLayoutContentAlignment>;

export const DoppeActionTypeWidgetContentLayoutNew = React.memo(function DoppeActionTypeWidgetContentLayoutNew(props: DoppeActionTypeWidgetContentLayoutNew.Props) {
    const {
        children,
        footer,
        sections,
        mainMedia,
        fullWidthMainMedia = false,
        contentAlignment = DoppeActionTypeWidgetContentLayoutContentAlignment.Default,
        isFixedHeight = false,
        noContentPadding = false,
        noContentSectionsPadding = false,

        className,
        ...htmlAttributes
    } = props;


    const doppeActionTypeWidgetLayoutContext = useContext(DoppeActionTypeWidgetLayoutContext)

    const forceMaxHeight = doppeActionTypeWidgetLayoutContext?.forceMaxHeight ?? false;
    const headerSpec = doppeActionTypeWidgetLayoutContext?.headerSpec ?? null;
    const isStrip = doppeActionTypeWidgetLayoutContext?.isStrip ?? false;

    const shouldRenderMainMediaInFullWidth = isStrip ? false : fullWidthMainMedia;

    const content = (
        <>
            {mainMedia ? (
                shouldRenderMainMediaInFullWidth ?
                    <div
                        className={style(classes.mainMediaContainer, {})}
                    >
                        {mainMedia}
                    </div>
                    :
                    <DoppeActionTypeWidgetContentSection
                        className={style(classes.mediaContentSection, {})}
                    >
                        <div
                            className={style(classes.mainMediaContainer, {})}
                        >
                            {mainMedia}
                        </div>
                    </DoppeActionTypeWidgetContentSection>
            ) : null}
            {
                children ?
                    <DoppeActionTypeWidgetContentSection
                        noPadding={noContentPadding}
                        className={style(classes.content)}
                        {...uiPartCreateMarking(DoppeActionTypeWidgetContentLayoutNewParts.Content)}
                    >
                        {children}
                    </DoppeActionTypeWidgetContentSection>
                    :
                    null
            }
        </>
    );

    return (
        <div
            {...htmlAttributes}
            className={style(
                classes.root,
                {
                    hasContent: !!children,
                    hasFooter: !!footer,
                    hasMainMedia: !!mainMedia,
                    contentAlignment: contentAlignment,
                    fullWidthMainMedia: shouldRenderMainMediaInFullWidth,
                    isFixedHeight: isFixedHeight,
                    noContentPadding: noContentPadding,
                    noContentSectionsPadding: noContentSectionsPadding,
                    forceMaxHeight: forceMaxHeight,
                    hasHeader: headerSpec !== null,
                    hasHeaderWithBottomBorder: headerSpec?.hasBorderBottom ?? false
                },
                className
            )}
        >
            {
                isFixedHeight ?
                    <DoppeViewerScrollView
                        className={style(classes.scrollView, {}, FlexLayout.fillRemainingVerticalSpace)}
                        scrolledContentWrapperClassName={style(classes.innerScrollContent, {}, FlexLayout.column.default)}
                        scrollingDirection={ScrollViewScrollingDirection.Vertical}
                    >
                        {content}
                    </DoppeViewerScrollView>
                    :
                    content
            }
            {footer ? (
                <DoppeActionTypeWidgetContentSection
                    className={style(classes.footerSection, {})}
                >
                    <div
                        className={style(classes.footerContent, {})}
                    >
                        {footer}
                    </div>
                </DoppeActionTypeWidgetContentSection>
            ) : null}
        </div>
    );
});

export namespace DoppeActionTypeWidgetContentLayoutNew {

    export interface Props extends React.HTMLAttributes<any> {
        footer?: React.ReactNode;
        sections?: DoppeActionContentSection[];
        mainMedia?: React.ReactNode;
        fullWidthMainMedia?: boolean;
        isFixedHeight?: boolean;
        contentAlignment?: DoppeActionTypeWidgetContentLayoutContentAlignment;
        noContentPadding?: boolean;
        noContentSectionsPadding?: boolean;
    }
}
